export const selectIsMealOptionsEventType = ({details}) => {
  if (details?.type) {
    const isMealOptionsOnViewInvitation = window.mealOptionsEventTypes?.[0].includes(details.type);
    const isMealOptionsOnCreateFlow = window.mealOptionsEventTypes?.includes(details.type);
    return isMealOptionsOnViewInvitation || isMealOptionsOnCreateFlow;
  }
  return false;
};

export const selectHasPoll = ({widgets}) => Boolean(widgets?.polls?.length);

export const selectHasWtb = ({widgets}) => Boolean(widgets?.whatToBrings?.length);

export const selectPolls = (state) => state.widgets.polls;
export const selectWhatToBrings = (state) => state.widgets.whatToBrings;
